var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Index,{attrs:{"login-route-name":"salesChannelManagementAppLogin","login-target-route":"salesChannelManagementApps"},on:{"login":_setup.onLogin}})
}
var staticRenderFns = []

export { render, staticRenderFns }